export enum BarekaRouterEnum {
  Practice = 'practice',
  KitchenSink = 'kitchensink',
  Test = 'test',
  TaskResult = 'test-result',
}
